import React, { useState } from 'react';

export default function LabelForm({ onClose, onSave }) {
  const [label, setLabel] = useState('');
  const [error, setError] = useState('');

  const handleSave = () => {
    if (!label.trim()) {
      setError('Please enter a label for this connection');
      return;
    }
    setError('');
    onSave(label);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.75)',
      backdropFilter: 'blur(8px)',
      zIndex: 1050,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem'
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '500px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        overflow: 'hidden',
        border: '1px solid rgba(148, 163, 184, 0.1)'
      }}>
        {/* Header Section */}
        <div style={{
          background: 'linear-gradient(135deg, #0891b2 0%, #0e7490 50%, #164e63 100%)',
          padding: '2rem 2.5rem 1.5rem',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Background Pattern */}
          <div style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '150px',
            height: '150px',
            background: 'radial-gradient(circle, rgba(6, 182, 212, 0.15) 0%, transparent 70%)',
            borderRadius: '50%',
            transform: 'translate(40%, -40%)'
          }}></div>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'relative',
            zIndex: 2
          }}>
            <div>
              <h2 style={{
                color: '#ffffff',
                fontSize: '1.5rem',
                fontWeight: '700',
                margin: '0 0 0.5rem 0',
                letterSpacing: '-0.025em'
              }}>
                Connection Label
              </h2>
              <p style={{
                color: 'rgba(255, 255, 255, 0.8)',
                fontSize: '0.95rem',
                margin: 0,
                fontWeight: '400'
              }}>
                Name this connection path
              </p>
            </div>
            
            <button
              onClick={onClose}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                color: 'white',
                width: '44px',
                height: '44px',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                fontSize: '1.2rem',
                transition: 'all 0.2s ease',
                backdropFilter: 'blur(10px)'
              }}
              onMouseEnter={e => {
                e.target.style.background = 'rgba(239, 68, 68, 0.2)';
                e.target.style.borderColor = 'rgba(239, 68, 68, 0.3)';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={e => {
                e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                e.target.style.transform = 'scale(1)';
              }}
            >
              ×
            </button>
          </div>
        </div>

        {/* Content Section */}
        <div style={{
          padding: '2rem 2.5rem',
          background: '#fafbfc'
        }}>
          {/* Error Alert */}
          {error && (
            <div style={{
              background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
              border: '1px solid #fca5a5',
              borderRadius: '12px',
              padding: '1rem 1.25rem',
              marginBottom: '1.5rem',
              display: 'flex',
              alignItems: 'center'
            }}>
              <div style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                background: '#ef4444',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '0.75rem',
                flexShrink: 0
              }}>
                <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>!</span>
              </div>
              <span style={{ color: '#dc2626', fontWeight: '500' }}>{error}</span>
            </div>
          )}
          
          {/* Input Section */}
          <div style={{ marginBottom: '2rem' }}>
            <label style={{
              display: 'block',
              fontSize: '1.125rem',
              fontWeight: '600',
              color: '#1f2937',
              marginBottom: '0.75rem'
            }}>
              Enter connection label
            </label>
            
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                value={label}
                onChange={(e) => setLabel(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="e.g., Yes, No, Continue, Next"
                autoFocus
                style={{
                  width: '100%',
                  padding: '1rem',
                  border: '2px solid #e2e8f0',
                  borderRadius: '12px',
                  fontSize: '1rem',
                  background: '#ffffff',
                  outline: 'none',
                  transition: 'all 0.2s ease',
                  boxSizing: 'border-box'
                }}
                onFocus={e => {
                  e.target.style.borderColor = '#0891b2';
                  e.target.style.boxShadow = '0 0 0 3px rgba(8, 145, 178, 0.1)';
                }}
                onBlur={e => {
                  e.target.style.borderColor = '#e2e8f0';
                  e.target.style.boxShadow = 'none';
                }}
              />
              {label.length > 0 && (
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  right: '1rem',
                  transform: 'translateY(-50%)',
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  background: '#10b981',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>✓</span>
                </div>
              )}
            </div>
            
            <p style={{
              fontSize: '0.875rem',
              color: '#6b7280',
              marginTop: '0.5rem',
              margin: '0.5rem 0 0 0'
            }}>
              This label will appear on the connection arrow between steps
            </p>
          </div>

          {/* Quick Options */}
          <div>
            <p style={{
              fontSize: '1rem',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '1rem'
            }}>
              Quick options:
            </p>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))', 
              gap: '0.75rem' 
            }}>
              {['Yes', 'No', 'Continue', 'Success', 'Failure', 'Next', 'Back'].map(option => (
                <button
                  key={option}
                  onClick={() => setLabel(option)}
                  style={{
                    padding: '0.75rem 1rem',
                    background: label === option 
                      ? 'linear-gradient(135deg, #0891b2 0%, #0e7490 100%)' 
                      : '#ffffff',
                    border: '2px solid',
                    borderColor: label === option ? '#0891b2' : '#e2e8f0',
                    borderRadius: '10px',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: label === option ? '#ffffff' : '#374151',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    textAlign: 'center',
                    boxShadow: label === option ? '0 2px 8px rgba(8, 145, 178, 0.25)' : 'none'
                  }}
                  onMouseEnter={e => {
                    if (label !== option) {
                      e.target.style.borderColor = '#0891b2';
                      e.target.style.background = 'rgba(8, 145, 178, 0.05)';
                      e.target.style.transform = 'translateY(-1px)';
                    }
                  }}
                  onMouseLeave={e => {
                    if (label !== option) {
                      e.target.style.borderColor = '#e2e8f0';
                      e.target.style.background = '#ffffff';
                      e.target.style.transform = 'translateY(0)';
                    }
                  }}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>

          {/* Help Text */}
          <div style={{
            marginTop: '1.5rem',
            padding: '1rem',
            background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
            border: '1px solid #bae6fd',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center'
          }}>
            <div style={{
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              background: '#0891b2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '0.75rem',
              flexShrink: 0
            }}>
              <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>i</span>
            </div>
            <span style={{ color: '#0369a1', fontSize: '0.875rem' }}>
              Press <strong>Enter</strong> to create the connection quickly
            </span>
          </div>
        </div>

        {/* Footer Section */}
        <div style={{
          padding: '1.5rem 2.5rem 2rem',
          background: '#ffffff',
          borderTop: '1px solid #e2e8f0',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '1rem'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '0.75rem 1.5rem',
              background: '#ffffff',
              border: '2px solid #d1d5db',
              borderRadius: '10px',
              color: '#374151',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={e => {
              e.target.style.background = '#f9fafb';
              e.target.style.borderColor = '#9ca3af';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={e => {
              e.target.style.background = '#ffffff';
              e.target.style.borderColor = '#d1d5db';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Cancel
          </button>
          
          <button
            onClick={handleSave}
            disabled={!label.trim()}
            style={{
              padding: '0.75rem 2rem',
              background: label.trim() 
                ? 'linear-gradient(135deg, #0891b2 0%, #0e7490 100%)' 
                : '#e5e7eb',
              border: 'none',
              borderRadius: '10px',
              color: label.trim() ? '#ffffff' : '#9ca3af',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: label.trim() ? 'pointer' : 'not-allowed',
              transition: 'all 0.2s ease',
              boxShadow: label.trim() ? '0 4px 14px 0 rgba(8, 145, 178, 0.25)' : 'none'
            }}
            onMouseEnter={e => {
              if (label.trim()) {
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 6px 20px 0 rgba(8, 145, 178, 0.35)';
              }
            }}
            onMouseLeave={e => {
              if (label.trim()) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 14px 0 rgba(8, 145, 178, 0.25)';
              }
            }}
          >
            Create Connection
          </button>
        </div>
      </div>
    </div>
  );
}